import { getExtension } from '@packages/core/utils';

export const CASE_ATTACHMENT_IMAGE_EXTENSIONS = ['png', 'jpg', 'jpeg', 'heic'] as const;
export const CASE_ATTACHMENT_VIDEO_EXTENSIONS = ['mov', 'mp4'] as const;
export const CASE_ATTACHMENT_FILE_EXTENSIONS = ['pdf', 'docx', 'txt', 'csv', 'zip'] as const;
export const CASE_ATTACHMENT_DIAGNOSTIC_EXTENSIONS = ['gtse', 'sepf', 'ssm', 'ssm3'] as const;

export const SUPPORTED_CASE_ATTACHMENT_EXTENSIONS = [
    ...CASE_ATTACHMENT_IMAGE_EXTENSIONS,
    ...CASE_ATTACHMENT_VIDEO_EXTENSIONS,
    ...CASE_ATTACHMENT_FILE_EXTENSIONS,
    ...CASE_ATTACHMENT_DIAGNOSTIC_EXTENSIONS,
] as const;

const SUPPORTED_CASE_ATTACHMENT_EXTENSION_SET = new Set(SUPPORTED_CASE_ATTACHMENT_EXTENSIONS);

export const CASE_ATTACHMENT_DROPZONE_HINT = `Images (${formatExtensions(
    CASE_ATTACHMENT_IMAGE_EXTENSIONS
)}) | Video (${formatExtensions(CASE_ATTACHMENT_VIDEO_EXTENSIONS)}) | Files (${formatExtensions(
    CASE_ATTACHMENT_FILE_EXTENSIONS
)}) | Diagnostic (${formatExtensions(CASE_ATTACHMENT_DIAGNOSTIC_EXTENSIONS)})`;

/**
 * Check whether a file is supported for Techline case attachments.
 *
 * @param file - the file selected by the user
 * @returns true when the file name has a supported case attachment extension
 */
export function isSupportedCaseAttachmentFile(file: File): boolean {
    return isSupportedCaseAttachmentFileName(file.name);
}

/**
 * Check whether a filename has a supported Techline case attachment extension.
 *
 * @param filename - the file name to validate
 * @returns true when the extension is allowed for case attachments
 */
export function isSupportedCaseAttachmentFileName(filename: string): boolean {
    return (SUPPORTED_CASE_ATTACHMENT_EXTENSION_SET as ReadonlySet<string>).has(getExtension(filename));
}

/**
 * Format a set of extensions for display in the dropzone hint.
 *
 * @param extensions - lowercase extensions without leading dots
 * @returns a comma-separated display string with leading dots
 */
function formatExtensions(extensions: readonly string[]): string {
    return extensions.map((extension) => `.${extension}`).join(', ');
}
